import './tcms_default_polyfills.js';
import './tcms_core.js';
import './tcms_base_wns.js';
import './tcms_base_scrollNavi.ts';
import './tcms_base_expandList.js';
import './tcms_base_initialize.js';
import '../../../widgets/widget.global.import.js';
import './tcms_base_hooks.js';
import './chatbot/tcms_chatbot.js';
import './unified_login/tcms_layer.js';

import('./tcms_base_anchorLocationJumper.ts');
import {
    onLCP, onINP, onCLS 
} from 'web-vitals';

function logWebVitals({
    name, rating, value, entries 
}) {
    let color;

    switch (rating) {
    case 'poor':
        color = 'red';
        break;
    case 'needs-improvement':
        color = 'orange';
        break;
    case 'good':
        color = 'green';
        break;
    default:
        color = 'white';
        break;
    }
    console.groupCollapsed(`Core Web Vitals: ${name} - rating: %c${rating} (${value})`, `color: ${color}`);
    console.table(entries);
    console.groupEnd();
}

onCLS(logWebVitals);
onINP(logWebVitals);
onLCP(logWebVitals);

/**
 * Reise-Navigation: set the active navigation item into screen center
 **/
const reiseNaviElement = document.querySelector('.c24-travel-nav');
const screenWidth = window.innerWidth;

if (reiseNaviElement && screenWidth < 772) {
    const activeNavItem = reiseNaviElement.querySelector('.c24-travel-bubble-ele.active');

    reiseNaviElement.scrollBy({
        top: 0,
        left: activeNavItem.offsetLeft - screenWidth / 2 + activeNavItem.scrollWidth / 2,
        behavior: 'smooth'
    });
}

if (
    !window.TCMS.showScrollNavigation &&
    window.TCMS.hasOwnProperty('travelCta') &&
    window.TCMS.travelCta.data.length > 0
) {
    const mainContent = document.getElementById('content');

    import('./classes/TcmsTravelCta.js').then(({ TcmsTravelCta }) => {
        if (window.TCMS.travelCta.instance === undefined) {
            window.TCMS.travelCta.instance = new TcmsTravelCta({
                travelCtaData: window.TCMS.travelCta.data,
                prependToNode: mainContent,
                useFixedPosition: true,
                eventTackingFunc: window.TCMS.trackingManager.eventTracking
            });
        }
    });
}

const modalWindowTriggerElems = document.querySelectorAll('.ck24_modal-trigger');

window.fireOnVisible(
    modalWindowTriggerElems,
    async(triggerElem) => {
        await import('./classes/TcmsModalWindow.js').then((ModalWindow) => {
            ModalWindow = ModalWindow.default;
            const modalContentId = triggerElem.dataset.modalSelector ?? '';
            const modalContent = window.TCMS?.modalWindow?.content[modalContentId] ?? '';
            const mobileSheet = triggerElem.dataset.modalMobileSheet ?? false;

            new ModalWindow(modalContent, {
                triggerElem: triggerElem,
                mobileSheet: mobileSheet
            });
        });
    },
    {
        parentContainer: document.querySelector('.c24-StationLocator_stationCounter')
    }
);

document.querySelectorAll('[data-accordion="true"]').forEach(function(accordionTriggerNode) {
    window.fireOnVisible(accordionTriggerNode, async() => {
        await import('./tcms_base_accordion.js').then(async(Accordion) => {
            await import('../styles/ck24_accordion.scss').then(function() {
                Accordion = Accordion.default;
                const accordion = new Accordion(accordionTriggerNode, {
                    isMobile: window.isMobileDetected
                });

                accordion.addToggleEventListener(accordionTriggerNode);
            });
        });
    });
});
